import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: {},
  filters: {},
};

export const ProfileSlice = createSlice({
  name: "ProfileReducer",
  initialState,
  reducers: {
    setProfileData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setProfileData } = ProfileSlice.actions;

export default ProfileSlice.reducer;
